export const messages = {
  addFilter: {
    key: 'filters.addFilter',
    defaultMessage: 'Add filter',
  },
  vendorFilter: {
    key: 'filters.vendorFilter',
    defaultMessage: 'Vendor',
  },
  customerFilter: {
    key: 'filters.customerFilter',
    defaultMessage: 'Customer',
  },
  assessmentTypeFilter: {
    key: 'filters.assessmentTypeFilter',
    defaultMessage: 'Type',
  },
  statusFilter: {
    key: 'filters.statusFilter',
    defaultMessage: 'Status',
  },
  parentOrganizationFilter: {
    key: 'filters.parentOrganizationFilter',
    defaultMessage: 'Organization',
  },
  groupFilter: {
    key: 'filters.groupFilter',
    defaultMessage: 'Group',
  },
  vendorStatusFilter: {
    key: 'filters.vendorStatusFilter',
    defaultMessage: 'Vendor status',
  },
  assessmentsFilter: {
    key: 'filters.assessmentsFilter',
    defaultMessage: 'Assessments',
  },
  subjectsFilter: {
    key: 'filters.subjectsFilter',
    defaultMessage: 'Subjects',
  },
  riskFilter: {
    key: 'filters.riskFilter',
    defaultMessage: 'Risk',
  },
  userFilter: {
    key: 'filters.userFilter',
    defaultMessage: 'User',
  },
  assessmentFilter: {
    key: 'filters.assessmentFilter',
    defaultMessage: 'Assessment',
  },
  questionFindingFilter: {
    key: 'filters.questionFindingFilter',
    defaultMessage: 'Question/Finding',
  },
  messageFilter: {
    key: 'filters.messageFilter',
    defaultMessage: 'Message',
  },
  subjectFilter: {
    key: 'filters.subjectFilter',
    defaultMessage: 'Subject',
  },
  notStarted: {
    key: 'filters.notStarted',
    defaultMessage: 'Not started',
  },
  completed: {
    key: 'filters.completed',
    defaultMessage: 'Completed',
  },
  inProgress: {
    key: 'filters.inProgress',
    defaultMessage: 'In progress',
  },
  pendingRequest: {
    key: 'filters.pendingRequest',
    defaultMessage: 'Pending request',
  },
  assessmentInProgress: {
    key: 'filters.assessmentInProgress',
    defaultMessage: 'Assessment in progress',
  },
  BORequestNotApproved: {
    key: 'filters.BORequestNotApproved',
    defaultMessage: 'BO request Not approved',
  },
  securityTeamApproved: {
    key: 'filters.securityTeamApproved',
    defaultMessage: 'Security team - Approved',
  },
  securityTeamDeclined: {
    key: 'filters.securityTeamDeclined',
    defaultMessage: 'Security team - Declined',
  },
  open: {
    key: 'filters.open',
    defaultMessage: 'Open',
  },
  closed: {
    key: 'filters.closed',
    defaultMessage: 'Closed',
  },
  pending: {
    key: 'filters.pending',
    defaultMessage: 'Pending',
  },
  filterPlaceholder: {
    key: 'filters.filterPlaceholder',
    defaultMessage: 'Select value',
  },
  myFilesFormatFilter: {
    key: 'filters.myFilesFormatFilter',
    defaultMessage: 'Format',
  },
  myFilesExpirationFilter: {
    key: 'filters.myFilesExpirationFilter',
    defaultMessage: 'Expiration',
  },
  all: {
    key: 'filters.all',
    defaultMessage: 'All',
  },
  docx: {
    key: 'filters.docx',
    defaultMessage: 'docx',
  },
  doc: {
    key: 'filters.doc',
    defaultMessage: 'doc',
  },
  xlsx: {
    key: 'filters.xlsx',
    defaultMessage: 'xlsx',
  },
  pdf: {
    key: 'filters.pdf',
    defaultMessage: 'pdf',
  },
  csv: {
    key: 'filters.csv',
    defaultMessage: 'csv',
  },
  jpg: {
    key: 'filters.jpg',
    defaultMessage: 'jpg',
  },
  jpeg: {
    key: 'filters.jpeg',
    defaultMessage: 'jpeg',
  },
  png: {
    key: 'filters.png',
    defaultMessage: 'png',
  },

  valid: {
    key: 'filters.valid',
    defaultMessage: 'Valid',
  },
  expiredSoon: {
    key: 'filters.expiredSoon',
    defaultMessage: 'Expiring soon',
  },
  expired: {
    key: 'filters.expired',
    defaultMessage: 'Expired',
  },
};

export default {
  prefix: 'filters',
  messages,
};
